module.exports = __webpack_public_path__ + "img/img-form-soluciones.62b9a049.webp";